import React from 'react';
import DatePicker from 'react-datepicker';
import { FilterContainer, SearchInput, Select } from './FilterBar.styles';

const FilterBar = ({ 
  searchTerm, 
  setSearchTerm, 
  statusFilter, 
  setStatusFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  hideDateFilters = false // <-- 1. Add new prop with a default value
}) => {
  return (
    <FilterContainer>
      <SearchInput
        type="text"
        placeholder={hideDateFilters ? "Search by filename..." : "Search documents..."}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
        <option value="All">All Statuses</option>
        <option value="Pending">Pending</option>
        <option value="Entered in Tally">Entered in Tally</option>
        <option value="Rejected">Rejected</option>
      </Select>
      
      {/* --- 2. Conditionally render the date pickers --- */}
      {!hideDateFilters && (
        <>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText="Start Date"
            isClearable
          />
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText="End Date"
            isClearable
          />
        </>
      )}
    </FilterContainer>
  );
};

export default FilterBar;